import { render, staticRenderFns } from "./zhengCe.vue?vue&type=template&id=0a92e76e&scoped=true"
import script from "./zhengCe.vue?vue&type=script&lang=js"
export * from "./zhengCe.vue?vue&type=script&lang=js"
import style0 from "./zhengCe.vue?vue&type=style&index=0&id=0a92e76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a92e76e",
  null
  
)

export default component.exports